// -- MODULES --
import { NgModule } from '@angular/core';
import { MaterialLibModule } from './material-lib.module';
import { CommonModule } from '@angular/common';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { AgGridModule } from 'ag-grid-angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { VrmDynamicFormsModule } from 'vrm-forms';

// -- COMPONENTS --
import { VrmPageContainerComponent } from './components/vrm-page-container/vrm-page-container.component';
import { VrmMentorReportsComponent } from './components/vrm-mentor-reports/vrm-mentor-reports.component';
import { VrmCasualReportComponent } from './components/vrm-casual-report/vrm-casual-report.component';
import { InsightSectionWrapperComponent } from './components/insight-components/insight-section-wrapper.component';
import { InsightCardComponent } from './components/insight-components/insight-card.component';
import { InsightLinearCardComponent } from './components/insight-components/insight-linear-card.component';
import { InsightMiniCardComponent } from './components/insight-components/insight-mini-card.component';
import { AccountInformationComponent } from './components/account-information/account-information.component';
import { DistributorAutocompleteSwitchComponent } from './components/distributor-autocomplete-switch/distributor-autocomplete-switch.component';
import { AppFooterComponent } from './components/app-footer/app-footer.component';
import { PasswordPolicyComponent } from './components/password/vrm-password-policy-info/password-policy.component';
import { InterventionInfoComponent } from './components/xs-components/intervention-info.component';

import { ReportDataNavComponent } from './components/report-data-nav/report-data-nav.component';
import { ReportDataMultiNavComponent } from './components/report-data-multi-nav/report-data-multi-nav.component';
import { VrmOrderMvrComponent } from './components/vrm-order-mvr/vrm-order-mvr.component';
import { VrmResolveAlertComponent } from './components/vrm-resolve-alert/vrm-resolve-alert.component';
import { ServerSideFilterComponent } from './components/server-side-filter/server-side-filter.component';
import { DialogHeaderComponent } from './dialogs/dialog-header/dialog-header.component';

// -- PIPES --
import { TruncateText } from './pipes/truncate-text.pipe';
import { TrustAsSafeHtmlPipe } from './pipes/trust-as-safe-html.pipe';
import { TrustAndConvertVrmHtmlPipe } from './pipes/trust-and-convert-vrm-html.pipe';
import { IeCompatibleDate } from './pipes/ie-compatible-date.pipe';
import { GetFormErrorMessage } from './pipes/get-form-error-message';
import { TranslateDateMonthPipe } from './pipes/translate-date-month.pipe';
import { MomentDatePipe } from './pipes/moment-date-format.pipe';
import { FilterTextTransformPipe } from './pipes/filter-text-transform.pipe';
import { TruncateStringPipe } from './pipes/truncate-string.pipe';

// -- DIRECTIVES --
import { VrmButtonDirective } from './directives/buttons/vrm-button.directive';
import { VrmRaisedButtonDirective } from './directives/buttons/vrm-raised-button.directive';
import { AutomationAttributeDirective } from './directives/automation-attr.directive';
import { VrmColorDirective } from './directives/colors/vrm-color.directive';
import { VrmBackgroundColorDirective } from './directives/colors/vrm-bg-color.directive';
import { VrmAccentDirective } from './directives/colors/vrm-accent.directive';
import { VrmBackgroundAccentDirective } from './directives/colors/vrm-bg-accent.directive';
import { GreenTextDirective } from './directives/green-text.directive';
import { AmberTextDirective } from './directives/amber-text.directive';
import { RedTextDirective } from './directives/red-text.directive';
import { HttpLoaderFactory } from './app.module';
import { HttpClient } from '@angular/common/http';
import { VrmPasswordStrengthComponent } from './components/vrm-password-strength/vrm-password-strength.component';

@NgModule({
  imports: [
    MaterialLibModule,
    FlexLayoutModule,
    TranslateModule,
    CommonModule,
    AgGridModule,
    FormsModule,
    ReactiveFormsModule,
    VrmDynamicFormsModule,
  ],
  declarations: [
    // -- COMPONENTS --
    VrmPageContainerComponent,
    VrmCasualReportComponent,
    VrmMentorReportsComponent,
    InsightSectionWrapperComponent,
    InsightCardComponent,
    InsightLinearCardComponent,
    InsightMiniCardComponent,
    AccountInformationComponent,
    DistributorAutocompleteSwitchComponent,
    AppFooterComponent,
    PasswordPolicyComponent,
    InterventionInfoComponent,

    ReportDataNavComponent,
    ReportDataMultiNavComponent,
    VrmOrderMvrComponent,
    VrmResolveAlertComponent,
    ServerSideFilterComponent,
    DialogHeaderComponent,
    VrmPasswordStrengthComponent,

    // -- PIPES --
    TruncateText,
    TrustAsSafeHtmlPipe,
    TrustAndConvertVrmHtmlPipe,
    IeCompatibleDate,
    GetFormErrorMessage,
    TranslateDateMonthPipe,
    MomentDatePipe,
    FilterTextTransformPipe,
    TruncateStringPipe,

    // -- DIRECTIVES --
    VrmButtonDirective,
    VrmRaisedButtonDirective,
    AutomationAttributeDirective,
    VrmColorDirective,
    VrmBackgroundColorDirective,
    VrmAccentDirective,
    VrmBackgroundAccentDirective,
    GreenTextDirective,
    AmberTextDirective,
    RedTextDirective,
  ],
  exports: [
    // -- COMPONENTS --
    VrmPageContainerComponent,
    VrmCasualReportComponent,
    VrmMentorReportsComponent,
    InsightSectionWrapperComponent,
    InsightCardComponent,
    InsightLinearCardComponent,
    InsightMiniCardComponent,
    AccountInformationComponent,
    DistributorAutocompleteSwitchComponent,
    AppFooterComponent,
    PasswordPolicyComponent,
    InterventionInfoComponent,

    ReportDataNavComponent,
    ReportDataMultiNavComponent,
    VrmOrderMvrComponent,
    VrmResolveAlertComponent,
    ServerSideFilterComponent,
    DialogHeaderComponent,
    VrmPasswordStrengthComponent,

    // -- PIPES --
    TruncateText,
    TrustAsSafeHtmlPipe,
    TrustAndConvertVrmHtmlPipe,
    IeCompatibleDate,
    GetFormErrorMessage,
    TranslateDateMonthPipe,
    MomentDatePipe,
    FilterTextTransformPipe,
    TruncateStringPipe,

    // -- DIRECTIVES --
    VrmButtonDirective,
    VrmRaisedButtonDirective,
    AutomationAttributeDirective,
    VrmColorDirective,
    VrmBackgroundColorDirective,
    VrmAccentDirective,
    VrmBackgroundAccentDirective,
    GreenTextDirective,
    AmberTextDirective,
    RedTextDirective,

    // -- MODULES --
    MaterialLibModule,
    CommonModule,
    TranslateModule,
    FlexLayoutModule,
    AgGridModule,
    FormsModule,
    ReactiveFormsModule,
    VrmDynamicFormsModule,
  ],
})
export class SharedModule {}
